import{useEffect as f}from"react";import"../useCopyToClipboard/useCopyToClipboard.js";import"../useFetch/useFetch.js";import i from"../useIsFirstRender/useIsFirstRender.js";function o(t,r){const e=i();f(()=>{if(!e)return t()},r)}export{o as default};
//# sourceMappingURL=useUpdateEffect.js.map
